import React from "react";
import Page from "../../../app/common/components/Page";
import { Button, Segment } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { HOME_PAGE_ROUTE } from "../../../app/api/routeConstants";
import { Redirect, useHistory } from "react-router-dom";
import { Form, Formik } from "formik";
import {
  AUTH_FACEBOOK_PROVIDER,
  AUTH_PASSWORD_PROVIDER,
  signInWithEmail,
} from "../../../app/firestore/firebaseService";
import MyTextInput from "../../../app/common/form/MyTextInput";
import MyPasswordInput from "../../../app/common/form/MyPasswordInput";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import useRedirectAuth from "../../../app/hooks/useRedirectAuth";
import { useCookies } from "react-cookie";
import { ADMIN_KEY_COOKIE, ONE_DAY } from "../../../app/layout/CookieWrapper";

export default function AccountSignInPage({
  accountType = "",
  alternative = null,
  alternativeSignInPage = null,
}) {
  const history = useHistory();

  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies();

  const { authenticated, currentUser } = useSelector((state) => state.auth);
  const { responsive, adminKey } = useSelector((state) => state.app);
  const { currentUserAccount } = useSelector((state) => state.account);

  useRedirectAuth({ shouldExecute: true });

  if (authenticated && !currentUserAccount) {
    return <LoadingComponent initialLoading={true} />;
  }

  if (
    authenticated &&
    [AUTH_PASSWORD_PROVIDER, AUTH_FACEBOOK_PROVIDER].includes(
      currentUser.providerId
    )
  ) {
    return <Redirect to={HOME_PAGE_ROUTE} />;
  }

  return (
    <Page
      title="Admin | Hello Radius"
      pageClassName=""
      extraStyles={{ marginTop: "5em" }}
      backgroundColour={"rgba(231, 244, 253, 0.3)"}
    >
      <div className="sign-in-page-form-container">
        <Segment
          className={
            !responsive.isMobile ? "sign-in-page" : "sign-in-page-mobile"
          }
          style={{ padding: 35 }}
          compact
          raised
        >
          <h2>{!adminKey ? "Enter access key" : "Sign in"}</h2>
          {alternative && (
            <div className="sign-in-page-account-sign-up">
              <span className="main-colour">Sign in as {alternative}? </span>
              <span
                className="text-link"
                onClick={() => {
                  history.push(alternativeSignInPage);
                }}
              >
                Click here
              </span>
            </div>
          )}
          <div style={{ margin: "34px 0", width: "100%" }}>
            {adminKey ? (
              <Formik
                initialValues={{ email: "", password: "" }}
                onSubmit={async (values, { setSubmitting, setErrors }) => {
                  try {
                    await signInWithEmail(values);
                    setSubmitting(false);
                  } catch (error) {
                    console.log(error);
                    setErrors({ auth: "Problem with username or password" });
                    setSubmitting(false);
                  }
                }}
              >
                {({ isSubmitting, isValid, dirty, errors, values }) => (
                  <Form className="ui form">
                    <span className="sign-in-page-input-title">Email</span>
                    <MyTextInput className="form-input-field" name="email" />
                    <div className="sign-in-page-password">
                      <span className="sign-in-page-input-title">Password</span>
                    </div>
                    <MyPasswordInput name="password" />
                    {errors.auth && (
                      <div
                        className="error-message absolute-position"
                        style={{ marginTop: 2 }}
                      >
                        {errors.auth}
                      </div>
                    )}
                    <Button
                      className="overwrite-button cta-long-button"
                      content={"Sign in"}
                      style={{ margin: "35px 0 0 0" }}
                      loading={isSubmitting}
                      disabled={!isValid || !dirty || isSubmitting}
                      type="submit"
                    />
                  </Form>
                )}
              </Formik>
            ) : (
              <Formik
                initialValues={{ key: "" }}
                onSubmit={async (values, { setSubmitting }) => {
                  setCookie(ADMIN_KEY_COOKIE, values.key, {
                    path: "/",
                    maxAge: ONE_DAY,
                  });
                  setSubmitting(false);
                }}
              >
                {({ isSubmitting, isValid, dirty }) => (
                  <Form className="ui form">
                    <MyPasswordInput name="key" />
                    <Button
                      className="overwrite-button cta-long-button"
                      content={"Continue"}
                      style={{ margin: "35px 0 0 0" }}
                      loading={isSubmitting}
                      disabled={!isValid || !dirty || isSubmitting}
                      type="submit"
                    />
                  </Form>
                )}
              </Formik>
            )}
          </div>
        </Segment>
      </div>
    </Page>
  );
}
